import React from "react";
import { Grid, TextField, Typography, Autocomplete } from "@mui/material";
import { styled } from "@mui/material/styles";
import CardTitle from "./CardTitle";

const CustomAutocomplete = styled(Autocomplete)(({ theme }) => ({
	"& .MuiOutlinedInput-root": {
		borderRadius: "50px",
	},
}));

function BasicDetails({
	formData,
	setFormData,
	inputErrors,
	dropDownValues,
	size,
	borderRadius,
}) {
	return (
		<Grid container spacing={2}>
			<CardTitle title="Basic details" />

			<Grid item xs={12} style={{ display: "flex", justifyContent: "left" }} spacing={2}>
				<CustomAutocomplete
					disablePortal
					size="small"
					id="title"
					options={["Mr.", "Mrs.", "Miss.", "Ms.", "Dr.", "Prof.", "Rabbi", "Reb."]}
					onChange={(e, newVal) => {
						setFormData({ ...formData, title: newVal });
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							error={inputErrors?.title}
							label="Title"
							required
						/>
					)}
				/>
			</Grid>

			<Grid item xs={12} sm={6} style={{ justifyContent: "flex-start" }}>
				<TextField
					value={formData?.firstName}
					size={size}
					id="firt_name_input"
					fullWidth
					required
					label="First name"
					variant="outlined"
					error={inputErrors?.firstName}
					onChange={(e) => setFormData({ ...formData, firstName: e?.target?.value })}
					InputProps={{ sx: { borderRadius: borderRadius } }}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextField
					size={size}
					id="last_name_input"
					fullWidth
					required
					label="Last name"
					variant="outlined"
					error={inputErrors?.lastName}
					onChange={(e) => setFormData({ ...formData, lastName: e?.target?.value })}
					InputProps={{ sx: { borderRadius: borderRadius } }}
				/>
			</Grid>

			<Grid item xs={12} sm={6} style={{ justifyContent: "flex-start" }}>
				<CustomAutocomplete
					isOptionEqualToValue={(positions, value) => positions === value}
					disablePortal
					disableCloseOnSelect
					size={size}
					multiple
					id="age-range"
					fullWidth
					options={dropDownValues?.ageRange || []}
					onChange={(e, newVal) => {
						setFormData({ ...formData, prefereAge: newVal });
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							required
							error={inputErrors?.prefereAge}
							label="Age range you work with (check all that apply)"
						/>
					)}
				/>
			</Grid>

			<Grid item xs={12} sm={6} style={{ justifyContent: "flex-start" }}>
				<CustomAutocomplete
					disablePortal
					disableCloseOnSelect
					isOptionEqualToValue={(positions, value) => positions === value}
					multiple
					size={size}
					id="single-plans"
					fullWidth
					options={dropDownValues?.singlePlan || []}
					onChange={(e, newVal) => {
						setFormData({ ...formData, singlesPlan: newVal });
					}}
					renderInput={(params) => (
						<TextField
							{...params}
							required
							error={inputErrors?.singlesPlan}
							label="Singles plan you work with (check all that apply)"
						/>
					)}
				/>
			</Grid>

			<Grid item xs={12} sm={6} style={{ justifyContent: "flex-start" }}>
				<CustomAutocomplete
					disablePortal
					disableCloseOnSelect
					isOptionEqualToValue={(positions, value) => positions === value}
					multiple
					id="single-type"
					size={size}
					fullWidth
					onChange={(e, newVal) => {
						setFormData({ ...formData, singlesType: newVal });
					}}
					options={dropDownValues?.singleType || []}
					renderInput={(params) => (
						<TextField
							{...params}
							required
							error={inputErrors?.singlesType}
							label="Singles type you work with (check all that apply)"
						/>
					)}
				/>
			</Grid>

			<Grid item xs={12} sm={6}>
				<CustomAutocomplete
					disablePortal
					disableCloseOnSelect
					isOptionEqualToValue={(positions, value) => positions === value}
					id="experience"
					fullWidth
					onChange={(e, newVal) => {
						setFormData({ ...formData, experience: newVal });
					}}
					size={size}
					options={dropDownValues?.experience || []}
					renderInput={(params) => (
						<TextField
							{...params}
							required
							error={inputErrors?.experience}
							label="Your experience as a shadchan"
						/>
					)}
				/>
			</Grid>
			<Grid item xs={12} sm={6} style={{ justifyContent: "flex-start" }}>
				<TextField
					value={formData?.ravsName}
					size={size}
					required
					id="special-instruction"
					fullWidth
					multiline
					rows={4}
					label="Rov's name, and contact info"
					placeholder="Please provide a Rov's name, and contact info, who can serve as a character reference for you."
					variant="outlined"
					error={inputErrors?.ravsName}
					onChange={(e) => setFormData({ ...formData, ravsName: e?.target?.value })}
					InputProps={{ sx: { borderRadius: borderRadius } }}
				/>
			</Grid>
			<Grid item xs={12} sm={6} style={{ justifyContent: "flex-start" }}>
				<TextField
					value={formData?.listOrgs}
					size={size}
					id="special-instruction"
					fullWidth
					multiline
					rows={4}
					label="Shidduch organizations you are affiliated with"
					placeholder="Please list any shidduch organizations you are, or have been, involved with."
					variant="outlined"
					onChange={(e) => setFormData({ ...formData, listOrgs: e?.target?.value })}
					InputProps={{ sx: { borderRadius: borderRadius } }}
				/>
			</Grid>
		</Grid>
	);
}

export default BasicDetails;
